import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import SmsesScreen from './containers/SmsesScreenContainer';
import SmsEditScreen from './containers/SmsEditScreenContainer';

const register = () => {
  Logger.log('debug', `smses.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'smses', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', {
      SmsEditScreen: [
        'PrivateRoute',
        '/smses/edit/:id([\\w\\-]+)',
        true,
        SmsEditScreen,
        getI18n().t('smses_route_edit'),
      ],
      SmsesScreen: [
        'PrivateRoute',
        '/smses/:page(\\d+)?',
        true,
        SmsesScreen,
        getI18n().t('smses_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `smses.register() loaded.`);
